<div class="primary-info-box" [ngClass]="{ disabled: status >= minStatus.appraisal_done }">
  <p class="info-text">
    {{ 'simple_note_title' | translate }}
    <a class="icon-a" (click)="openModal('simpleNote')" id="appraisal-from-has-simple-note-info">
      <img class="ico-info" src="assets/img/info.png" />
    </a>
  </p>
  <div class="row date-row w-switch">
    <hr class="divider" />
    <div class="col-lg-3 col-sm-4 col-6 input-top-reset">
      <label>{{ 'simple_note_has_simple_note' | translate }}</label>
    </div>
    <div class="switch-group col-lg-3 col-sm-2 col-6 no-pd input-top-reset">
      <label class="switch" id="appraisal-from-label-has-simple-note">
        <input
          [disabled]="status >= minStatus.appraisal_done"
          [(ngModel)]="hasSimpleNote"
          (change)="hasSimpleNoteChanged()"
          type="checkbox"
        />
        <span class="slider round">
          <span> {{ 'yes' | translate }} </span>
          <span> {{ 'no' | translate }} </span>
        </span>
      </label>
    </div>

    @if (hasSimpleNote) {
      <div class="col-lg-6 col-sm-6 col-12 input-top-reset">
        <a
          id="appraisal-from-upload-simple-note"
          class="animated fadeIn btn btn-02 btn-add"
          href="javascript:;"
          (click)="openModalUploadFile()"
          >{{ 'simple_note_has_send_simple_note' | translate }}</a
        >
      </div>
    }
  </div>
</div>
